<template>
  <div>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th class="text-center" colspan="9">DÖNEM BİLGİLERİ</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <small class="d-block">ORTAK ALAN</small>
          % {{ HesapVeri.Hesap.FaturaBilgi.oAlan }}
        </td>
        <td>
          <small class="d-block">ORTAK ALAN BEDELİ</small>
          {{ HesapVeri.Hesap.oAlanHesap }} <sup>TL</sup>
        </td>
        <td>
          <small class="d-block">FATURA BEDELİ</small>
          {{ HesapVeri.Hesap.FaturaBilgi.tutar }} <sup>TL</sup>
        </td>
        <td>
          <small class="d-block">TÜKETİM HACİM</small>
          {{ HesapVeri.Hesap.FaturaBilgi.hacim }} <sup>kWh</sup>
        </td>
        <td>
          <small class="d-block">ISINMA TÜKETİM BEDELİ</small>
          {{ HesapVeri.Hesap.TuketimHesap }} <sup>TL</sup>
        </td>
        <td v-if="HesapVeri.Hesap.SicakSu">
          <small class="d-block">SICAK SU</small>
          {{ HesapVeri.Hesap.Toplam.sTuketim }} <sup>TL</sup>
        </td>
        <td v-if="HesapVeri.Hesap.SicakSu">
          <small class="d-block">ŞEBEKE</small>
          {{ HesapVeri.Hesap.Toplam.sSebeke }} <sup>TL</sup>
        </td>
        <td>
          <small class="d-block">OKUNAN KWH BİRİM</small>
          {{ okWhBirim }} <sup>TL</sup>
        </td>
        <td>
          <small class="d-block">HESAP KWH BİRİM</small>
          {{ kWhBirim }} <sup>TL</sup>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="HesapVeri" class="scrollkaydiry" :style="'height: '+Height+'px'">
      <table class="table table-bordered table-sayac table-xs table-hover">
        <thead>
        <tr>
          <th class="text-center" :colspan="HesapVeri.Hesap.Ekstra?7:6">Genel Bilgi</th>
          <th class="text-center" colspan="3" v-if="HesapVeri.Hesap.SicakSu">Sıcak Su</th>
          <th class="text-center" colspan="6">Isınma</th>
        </tr>
        <tr>
          <th width="250">Mesken</th>
          <th width="50">Okunan</th>
          <th width="50">Hesap</th>
          <th width="100">Hx
            <el-tooltip class="item" effect="dark" content="kWh Çarpanı = çarpan*m2=kwh" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </th>

          <th width="150">Çarpan</th>
          <th width="50" class="text-right">Okuma Bedeli</th>
          <th width="50" class="text-right" v-if="HesapVeri.Hesap.Ekstra">{{ HesapVeri.Hesap.Ekstra }}</th>
          <th width="50" class="text-right" v-if="HesapVeri.Hesap.SicakSu">Tüketim <sup>(M3)</sup></th>
          <th width="50" class="text-right" v-if="HesapVeri.Hesap.SicakSu">Şebeke Bedeli</th>
          <th width="50" class="text-right" v-if="HesapVeri.Hesap.SicakSu">Su Isıtma Bedeli</th>
          <th width="50" class="text-right">Ortak Alan</th>
          <th width="50" class="text-right">Tüketim Ücreti</th>
          <th width="50" class="text-right">Muaf Mesken Payı</th>
          <th width="50" class="text-right">Muafiyet Oranı <sup>(%)</sup></th>
          <th width="50" class="text-right">Toplam Ödenecek</th>
        </tr>
        </thead>
        <tbody>
        <tr :class="l.Uyari?l.UyariClass:''" v-for="l in HesapVeri.Liste">
          <td>
            <el-popover
              placement="right"
              width="400"
              trigger="click">
              <table v-if="PopoverMeskenDetay" class="table table-bordered table-sayac table-xs table-hover">
                <thead>
                <tr>
                  <th class="text-center" colspan="6">{{ PopoverMeskenBilgi }}</th>
                </tr>
                <tr>
                  <th class="text-center" colspan="6">GEÇMİŞ OKUMA DETAYLARI</th>
                </tr>
                <tr>
                  <th>TARİH</th>
                  <th>TÜR</th>
                  <th>İLK</th>
                  <th>SON</th>
                  <th>FARK</th>
                  <th>CEZA</th>
                </tr>
                </thead>
                <tbody v-for="f in PopoverMeskenDetay">
                <tr v-if="f.KalSayac">
                  <td>{{ f.Fatura.starih }}</td>
                  <td>Kalorimetre</td>
                  <td>{{ f.KalSayac.Ilk }}</td>
                  <td>{{ f.KalSayac.Son }}</td>
                  <td>{{ f.KalSayac.Fark }}</td>
                  <td>{{ f.iFark }}</td>
                </tr>
                <tr v-if="f.SuSayac">
                  <td>{{ f.Fatura.starih }}</td>
                  <td>Su</td>
                  <td>{{ f.SuSayac.Ilk }}</td>
                  <td>{{ f.SuSayac.Son }}</td>
                  <td>{{ f.SuSayac.Fark }}</td>
                  <td>-</td>
                </tr>
                </tbody>
              </table>
              <hr v-if="PopoverMeskenNotlar">
              <table v-if="PopoverMeskenNotlar" class="table table-bordered table-sayac table-xs table-hover">
                <thead>
                <tr>
                  <th class="text-center" colspan="3">MESKEN NOTLARI</th>
                </tr>
                <tr>
                  <th>TARİH</th>
                  <th>EKLEYEN</th>
                  <th>NOT</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="n in PopoverMeskenNotlar">
                  <td>{{ n.tarih }}</td>
                  <td>{{ n.Kullanici }}</td>
                  <td>{{ n.Icerik }}</td>
                </tr>
                </tbody>
              </table>
              <el-button @click="KisiBilgi(l.Mesken_id,l.MeskenBilgi)" icon="el-icon-search" slot="reference" circle
                         size="mini"></el-button>
            </el-popover>
            <b class="float-right"><sup>{{ l.m2 }}m2</sup></b>
            <el-tooltip v-if="l.MahsupOlayi" class="item" effect="dark" content="Sol kısımdaki büyüteçten önceki ayların cezaları toplanarak Hesap kWh üzerine tıklanarak Mahsuplaştırma yapılabilir." placement="top">
            <el-tag size="mini" type="danger"><b>MAHSUP</b></el-tag>
            </el-tooltip>
            {{ l.MeskenBilgi }}
          </td>
          <td :class="l.Uyari?'text-kirmizi':'text-mavi'">
            <el-tooltip v-if="l.KalSayac.TarihFark>3" :content="'Son başarılı okuma '+l.KalSayac.TarihFark+' gün önce alınmış.'" placement="top">
              <i v-if="l.KalSayac.TarihFark>3" class="el-icon-date text-sari float-right"></i>
            </el-tooltip>
            <el-tooltip v-if="l.d15" content="15 Derece Kuralına Takıldı" placement="top">
              <i v-if="l.d15" class="el-icon-warning text-kirmizi float-right"></i>
            </el-tooltip>
            <el-tooltip v-if="l.Uyari" :content="l.Uyari" placement="top">
                 <span>
                  <i :class="l.UyariIcon"></i>{{ l.Tuketim }}<sup>kWh</sup>
                   </span>
            </el-tooltip>

            <span v-if="!l.Uyari">
                {{ l.Tuketim }}<sup>kWh</sup></span>

          </td>
          <td>
            <el-popover
              placement="top"
              width="80"
              trigger="click">
            <span slot="reference">
            {{ ((l.Carpan * l.m2) - l.Mahsup).toFixed(0) }}<sup>kWh</sup>

            <sup v-if="l.Mahsup>0"
                 style="background: red;padding: 3px;color: #ffffff;font-weight: bold;border-radius:4px">{{
                l.Mahsup
              }}</sup>
              </span>
              <div style="padding: 10px">
                <label>Mahsup kWh</label>
                <input style="width: 100%;padding: 5px" @change="tHesapla()"
                       v-model="l.Mahsup"></input>
              </div>
            </el-popover>
          </td>
          <td><input style="width: 80px !important;border:none !important;" @change="tHesapla()"
                     v-model="l.Carpan"></input>
          </td>
          <td>
            <el-select v-model="l.Carpan" @change="tHesapla()" style="width: 80px" size="mini"
                       placeholder="Select">
              <el-option label="15 Derece" :value="l.h15"></el-option>
              <el-option label="Okunan Değer" :value="l.Birim"></el-option>
              <el-option label="Bina Ortalaması" :value="l.hO"></el-option>
              <el-option label="Bina En Yükseği" :value="l.hY"></el-option>
            </el-select>
          </td>
          <td class="text-right">{{ l.Okuma }}<sup>TL</sup></td>
          <td class="text-right" v-if="HesapVeri.Hesap.Ekstra">
            <input style="width: 80px !important;border:none !important;" @change="tHesapla()"
                   v-model="l.Ekstra"></input></td>
          <td class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ l.sBirim }}<sup>M3</sup></td>
          <td class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ l.sSebeke }}<sup>TL</sup></td>
          <td class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ l.sTuketim }}<sup>TL</sup></td>
          <td class="text-right">{{ l.oAlan }}<sup>TL</sup></td>
          <td class="text-right">{{ l.tUcret }}<sup>TL</sup></td>
          <td class="text-right">{{ l.MuafPay }}<sup>TL</sup></td>
          <td class="text-right">{{ l.Muafiyet }}</td>
          <td class="text-right">{{ l.Odenecek }}<sup>TL</sup></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="text-right">{{ HesapVeri.Hesap.gM2 }}<sup>m2</sup></th>
          <th>{{ HesapVeri.Hesap.tEnerji }}<sup>kWh</sup></th>
          <th>{{ CarpanHesap }}<sup>kWh</sup></th>
          <th colspan="2"></th>
          <th class="text-right">{{ AltToplam.Okuma }}<sup>TL</sup></th>
          <th class="text-right" v-if="HesapVeri.Hesap.Ekstra">{{ HesapVeri.Hesap.eTutar }}<sup>TL</sup></th>
          <th class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ HesapVeri.Hesap.Toplam.sBirim }}<sup>M3</sup></th>
          <th class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ HesapVeri.Hesap.Toplam.sSebeke }}<sup>TL</sup>
          </th>
          <th class="text-right" v-if="HesapVeri.Hesap.SicakSu">{{ HesapVeri.Hesap.Toplam.sTuketim }}<sup>TL</sup>
          </th>
          <th class="text-right">{{ AltToplam.oAlan }}<sup>TL</sup></th>
          <th class="text-right">{{ AltToplam.tUcret }}<sup>TL</sup></th>
          <th class="text-right">{{ AltToplam.MuafPay }}<sup>TL</sup></th>
          <th class="text-right"></th>
          <th class="text-right">{{ AltToplam.Odenecek }}<sup>TL</sup></th>
        </tr>
        </tfoot>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  props: ['HesapVeri'],
  data() {
    return {
      Height: window.innerHeight - 260,
      PopoverMeskenDetay: null,
      PopoverMeskenNotlar: null,
      PopoverMeskenBilgi: null,
      CarpanHesap: 0,
      kWhBirim: 0,
      okWhBirim: 0,
      MuafM2: 0,
      MuafTutar: 0,
      AltToplam: {
        Okuma: 0,
        SicakSum3: 0,
        SicakSuBirim: 0,
        SicakSu: 0,
        oAlan: 0,
        tUcret: 0,
        MuafPay: 0,
        Odenecek: 0
      }
    }
  },
  methods: {
    KisiBilgi(Mesken_id, Bilgi) {
      this.PopoverMeskenDetay = null
      this.PopoverMeskenNotlar = null
      this.PopoverMeskenBilgi = Bilgi


      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/meskenonizleme/' + Mesken_id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.PopoverMeskenDetay = response.Detay
            this.PopoverMeskenNotlar = response.Notlar
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    },
    tHesapla() {
      this.CarpanHesap = 0;
      this.MuafTutar = 0;
      this.MuafM2 = 0;
      this.HesapVeri.Liste.forEach(row => {
        var Hesaplama = ((Number(row.Carpan) * Number(row.m2)) - Number(row.Mahsup)).toFixed(0);
        this.CarpanHesap += Number(Hesaplama);
        if (row.Muafiyet == 0) this.MuafM2 += Number(row.m2);
      });
      this.kWhHesap();
    },
    kWhHesap() {
      this.kWhBirim = (this.HesapVeri.Hesap.TuketimHesap / this.CarpanHesap).toFixed(6);
      this.HesapVeri.Liste.forEach(row => {
        var YenikWh = ((Number(row.Carpan) * Number(row.m2)) - Number(row.Mahsup)).toFixed(0)
        var YeniTutar = Number(YenikWh) * this.kWhBirim;
        row.tUcret = YeniTutar.toFixed(2);
        row.iFark = YenikWh - row.Tuketim
        row.kWhBirim = this.kWhBirim
        row.okWhBirim = this.okWhBirim
        if (row.Muafiyet > 0) {
          row.MuafUcret = (Number(row.tUcret) * Number(row.Muafiyet) / 100);
          this.MuafTutar += row.MuafUcret;
          // ORTAK ALANSA EĞER KOMPLE MUAF
          if (row.Muafiyet == 100) {
            this.MuafTutar += Number(row.Okuma);
          }
        }
        row.tUcret = (row.tUcret - row.MuafUcret).toFixed(2);
      });
      //MUAFİYET HESABI
      var mm2 = this.MuafTutar / this.MuafM2;
      if (this.HesapVeri.Hesap.Ekstra) this.HesapVeri.Hesap.eTutar = 0
      this.HesapVeri.Liste.forEach(row => {
        if (row.Muafiyet == 0) {
          row.MuafPay = (row.m2 * mm2).toFixed(2)
        }
        var OkumaUcreti = row.Okuma;
        if (row.Muafiyet == 100) OkumaUcreti = 0;
        row.Odenecek = (Number(row.sSebeke) + Number(row.sTuketim) + Number(row.Ekstra) + Number(OkumaUcreti) + Number(row.oAlan) + Number(row.tUcret) + Number(row.MuafPay)).toFixed(2);
        // if (row.Muafiyet == 100) row.Odenecek = Number(0).toFixed(2);
        if (this.HesapVeri.Hesap.Ekstra) {
          this.HesapVeri.Hesap.eTutar += Number(row.Ekstra)
        }
      });
      this.Toplamlar()
    },
    Toplamlar() {
      this.AltToplam = {
        Okuma: 0,
        oAlan: 0,
        tUcret: 0,
        MuafPay: 0,
        Odenecek: 0
      }
      this.HesapVeri.Liste.forEach(row => {
        this.AltToplam.Okuma += Number(row.Okuma);
        this.AltToplam.oAlan += Number(row.oAlan);
        this.AltToplam.tUcret += Number(row.tUcret);
        this.AltToplam.MuafPay += Number(row.MuafPay);
        this.AltToplam.Odenecek += Number(row.Odenecek);
      });
      this.AltToplam.Okuma = this.AltToplam.Okuma.toFixed(2);
      this.AltToplam.oAlan = this.AltToplam.oAlan.toFixed(2);
      this.AltToplam.tUcret = this.AltToplam.tUcret.toFixed(2);
      this.AltToplam.MuafPay = this.AltToplam.MuafPay.toFixed(2);
      this.AltToplam.Odenecek = this.AltToplam.Odenecek.toFixed(2);
    }
  },
  created() {
    this.CarpanHesap = this.HesapVeri.Hesap.tCarpan;
    this.okWhBirim = this.HesapVeri.Hesap.kWhBirim;
    this.tHesapla()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Donem/KisHesaplamasi.vue